import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';

export const railValidators: Partial<
  Record<UIDAPresentationTypeEnum, (category: KuxFilteredCategoriesDTO) => boolean>
> = {
  [UIDAPresentationTypeEnum.collection]: validateCollection,
  [UIDAPresentationTypeEnum.hero]: validateCollection,
  [UIDAPresentationTypeEnum.top_shelf_carousel]: validateCollection,
  [UIDAPresentationTypeEnum.series_catch_up]: validateCollection,
};

function validateCollection(category: KuxFilteredCategoriesDTO) {
  return Boolean(category.channels?.[0]);
}
